
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import Empty from "@/components/empty.vue";
import Share from "../components//share.vue";
import {
  GetPlanData,
  GetPlanGroupList,
  PatchEditPlan,
  DelPlan,
  GetGroupData,
  PostAddPlan,
  PostSortPlanGroup,
  PostSortPlan,
  PostSharePlan,
} from "@/request/common";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Empty,
    Share,
  },
})
export default class Name extends Vue {
  private list: any = [];
  private data: any = {};
  private cSelect: any = {};
  private ifShowEdit: any = false;
  private ifShowShare: any = false;
  private shareData: any = [];
  private ifShowShareSelect: any = false;
  private shareSelectData: any = {
    dept: [],
    user: [],
  };
  private editData: any = {};
  private searchText: any = "";
  private groups: any = [];
  private planTypeOption: any = [
    {
      label: "非随访类",
      options: [
        {
          value: "健康测评数据",
          label: "健康测评数据",
        },
        {
          value: "健康设备数据",
          label: "健康设备数据",
        },
        {
          value: "诊疗信息",
          label: "诊疗信息",
        },
        {
          value: "定制方案",
          label: "定制方案",
        },
        {
          value: "四诊客观化数据",
          label: "四诊客观化数据",
        },
      ],
    },
    {
      label: "随访类",
      options: [
        {
          value: "随访管理",
          label: "随访管理",
        },
        {
          value: "通用访视",
          label: "通用访视",
        },
        {
          value: "固定访视",
          label: "固定访视",
        },
        {
          value: "综合评估",
          label: "综合评估",
        },
      ],
    },
  ];
  private defaultProps: any = {
    children: "children",
    label: "name",
  };
  private delShare(index: any, key: any) {
    this.$confirm("您是否确定删除？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      this.shareSelectData[key].splice(index, 1);
    });
  }
  private shareDataChange(e: any) {
    this.shareSelectData = e;
    this.ifShowShareSelect = false;
  }
  private openShare() {
    let dept: any = [];
    let user: any = [];
    this.cSelect.shared_dept.forEach((ele: any) => {
      ele.uid = "dept" + ele.id;
      ele.type = "dept";
      dept.push(ele);
    });
    this.cSelect.shared_user.forEach((ele: any) => {
      ele.uid = "user" + ele.id;
      ele.type = "user";
      user.push(ele);
    });
    this.shareSelectData = {
      dept: dept,
      user: user,
    };
    this.ifShowShare = true;
  }
  private saveShare() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      selected_list: this.shareSelectData.dept.concat(
        this.shareSelectData.user
      ),
      plan: this.cSelect,
    };
    PostSharePlan(this, params, loading).then((res: any) => {
      this.$message.success("保存成功");
      this.getList();
      this.ifShowShare = false;
    });
  }
  private openShareSelect() {
    this.ifShowShareSelect = true;
  }
  private goPreview(item: any) {
    this.$router.push({
      path: "/main/manage/plan-preview",
      query: {
        group_id: item.group.id,
      },
    });
  }
  private delGroup(item: any) {
    this.$confirm("您确定删除吗？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      let arr: any = [];
      this.data.group.forEach((ele: any) => {
        if (ele.id !== item.id) {
          arr.push(ele.group);
        }
      });
      const params: any = {
        group: arr,
      };
      PatchEditPlan(this, this.cSelect.id, params, loading).then((res: any) => {
        this.$message.success("删除成功");
        this.getList();
        this.getData();
      });
    });
  }
  private handlePlanDrop() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      plans: this.list,
    };
    PostSortPlan(this, params, loading).then((res: any) => {
      this.getList();
    });
  }
  private handleDrop() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      plan_groups: this.data.group,
    };
    PostSortPlanGroup(this, params, loading).then((res: any) => {
      this.getData();
    });
  }
  private selectOne(items: any) {
    this.cSelect = items;
    this.getData();
  }
  private delOne(item: any) {
    this.$confirm("您是否确定删除？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelPlan(this, item.id, loading).then((res: any) => {
        this.$message.success("删除成功");
        // 如果删除的是当前的需要处理数据
        if (this.cSelect.id == item.id) {
          this.data = {};
          this.cSelect = {};
          this.getList();
        } else {
          this.getList();
        }
      });
    });
  }
  private openEdit(item: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {};
    }
    this.getGroups();
    this.ifShowEdit = true;
  }
  private getGroups() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: "-update_datetime",
      },
    };
    GetGroupData(this, params, loading).then((res: any) => {
      this.groups = res.data;
    });
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (type == "inner") {
      return false;
    } else {
      return true;
    }
  }
  private getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        search: this.searchText,
        // ordering: "-update_datetime",
      },
    };
    GetPlanData(this, params, loading).then((res: any) => {
      this.list = res.data;
      console.log("获取数据");
      console.log(this.list);
      if (!this.cSelect.id && this.list.length > 0) {
        this.cSelect = this.list[0];
        this.getData();
      } else {
        // 需要更新当前选中信息
        this.list.forEach((ele: any) => {
          if (ele.id == this.cSelect.id) {
            this.cSelect = ele;
          }
        });
      }
    });
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        plan: this.cSelect.id,
      },
    };
    GetPlanGroupList(this, params, loading).then((res: any) => {
      this.data = {
        group: res.data,
      };
    });
  }
  private save() {
    console.log(this.editData);
    if (!this.editData.name) {
      this.$message.error("请输入访视计划名称");
      return;
    }
    if (!this.editData.related_type) {
      this.$message.error("请选择关联类型");
      return;
    }
    if (!this.editData.group || this.editData.group.length < 1) {
      this.$message.error("请选择关联CRF组合");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (this.editData.id) {
      PatchEditPlan(this, this.editData.id, this.editData, loading).then(
        (res: any) => {
          this.$message.success("保存成功");
          this.getList();
          this.ifShowEdit = false;
          // 如果编辑的是当前选中的需要刷新数据
          if (this.editData.id == this.cSelect.id) {
            this.getData();
          }
        }
      );
    } else {
      PostAddPlan(this, this.editData, loading).then((res: any) => {
        this.$message.success("保存成功");
        this.getList();
        this.ifShowEdit = false;
      });
    }
  }
  private mounted() {
    this.getList();
  }
}
